module.exports = __webpack_public_path__ + "img/all-pages-unactive.219211e.svg";